import { ConfirmationModal } from "@libs/zapi-ui/custom";
import { ChatMessageList } from "./ChatMessageList";
import { ChatForm } from "./ChatForm";
import { useChat } from "../hooks/useChat";

export function ChatIsland() {
  const {
    projectId,
    messages,
    isLoading,
    loadingMessageId,
    isGeneratingChapter,
    progressMessage,
    prereqsChaptersToBeGenerated,
    isConfirmationDialogOpen,
    hasMessages,
    handleSubmit,
    handleAbortRequest,
    handleClearChat,
    openConfirmationDialog,
    closeConfirmationDialog,
    isInitializing,
    isSendingRequest,
    isAbortingRequest
  } = useChat();

  return (
    <div className="flex flex-col h-full">
      <ChatMessageList
        isInitializing={isInitializing}
        messages={messages}
        loadingMessageId={loadingMessageId}
        isGeneratingChapter={isGeneratingChapter}
        progressMessage={progressMessage}
        prereqsChaptersToBeGenerated={prereqsChaptersToBeGenerated}
      />

      <ChatForm
        projectId={projectId}
        isLoading={isLoading}
        onSubmit={handleSubmit}
        onClearChat={openConfirmationDialog}
        onAbortRequest={handleAbortRequest}
        hasMessages={hasMessages}
        disabled={isInitializing}
        isSendingRequest={isSendingRequest}
        isAbortingRequest={isAbortingRequest}
      />

      <ConfirmationModal
        isOpen={isConfirmationDialogOpen}
        onConfirm={handleClearChat}
        onClose={closeConfirmationDialog}
        title="Clear chat"
        description="Are you sure you want to clear the chat?"
      />
    </div>
  );
}
